class CustomProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.addButton = this.querySelector("button[type='submit']");
    this.cart = document.querySelector("cart-drawer");
    this.addToCart = this.addToCart.bind(this);
  }

  connectedCallback() {
    if (this.addButton && !this.addButton.hasAttribute("disabled")) {
      this.addButton.addEventListener("click", this.addToCart);
    }
  }

  disconnectedCallback() {
    if (this.addButton) {
      this.addButton.removeEventListener("click", this.addToCart);
    }
  }

  async addToCart(event) {
    event.preventDefault();
    if (!this.form) return;

    console.log('atc-hit')

    const formData = new FormData(this.form);
    this.addButton.classList.add("loading");

    try {
      if (this.cart) {
        formData.append(
          "sections",
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
      }

      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Failed to add to cart");

      const cartData = await response.json();

      // If on cart page, reload after adding product
      if (window.location.pathname === "/cart") {
        window.location.reload();
        return;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "product-form",
        productVariantId: formData.get("id"),
        cartData: cartData,
      });

      this.addButton.classList.remove("loading");
      this.cart.renderContents(cartData);
    } catch (error) {
      console.error(error);
      this.addButton.classList.remove("loading");
    }
  }
}

customElements.define("bm-custom-product-form", CustomProductForm);
